import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export interface ActionsProps {
  readonly children: React.ReactNode;
  readonly sx?: SxProps<Theme>;
}

export const Actions: React.FC<ActionsProps> = (props: ActionsProps): React.ReactElement => {
  const { children, sx } = props;

  return <Box sx={[styles.actions, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Box>;
};

const styles: Record<string, SystemStyleObject> = {
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    mt: 2,
  },
};
